"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using double at signs (`@@` `@@`).
 * Matches tags of the form `@@variable@@` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello @@variable@@';
 * const result = replaceTags(text, { variable: 'world' }, DoubleAtSigns);
 * console.log(result); // Output: 'Hello world'
 */
var DoubleAtSigns = {
    name: "Double At Signs",
    openingTag: "@@",
    closingTag: "@@",
    tagPattern: /@@[^@]+@@/g,
    tagStartPattern: /^@@/,
    tagEndPattern: /@@$/,
};
exports.default = DoubleAtSigns;
